import React, { useState } from 'react'
import { useTranslate, useNotify, useStore } from 'react-admin'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { Delete, Add, Edit } from '@mui/icons-material'
import Button from '@mui/material/Button'
import { userServices } from 'src/services/auth/user/user.service'
import { Skeleton } from '@mui/material'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_EDIT } from 'src/helper/Permission'

export const TableDevicesByClient = ({ list, setList }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [loading, setLoading] = useState(false)
  const hasDevicesEditPermissions = hasPermissionFunction('devices-by-user', PERMISSION_EDIT)

  const handleButton = async (id, is_active, user_id) => {
    try {
      setLoading(true)
      const response = await userServices.changeIsActiveDevices(id, { is_active: !is_active, user_id })
      if (!response) {
        notify(translate('ra.notification.error_updated'), { type: 'error' })
        setLoading(false)
      }

      const newList = list?.map((item) => {
        if (item.id === id) {
          return { ...item, is_active: !is_active }
        }
        return item
      })
      setList(newList)
      setLoading(false)
    } catch (error) {
      notify(translate('ra.notification.error_updated'), { type: 'error' })
      setLoading(false)
    }
  }

  const formatDateTime = (dateTime) => {
    if(dateTime){
      const date = dateTime.split(' ')[0]
      const time = dateTime.split(' ')[1]

      const day = date.split('-')[2]
      const month = date.split('-')[1]
      const year = date.split('-')[0]

      return day + '/' + month + '/' + year + ' ' + time
    }
    return dateTime
  }

  return (
    <>
      {loading ? (
        <Skeleton variant='rectangular' width={'100%'} height={400} />
      ) : (
        <TableContainer component={Paper} sx={{ marginY: '30px' }}>
          <Table sx={{ minWidth: 650 }} aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell align='left' width={'30%'}>{translate('ra.title.user_agent')}</TableCell>
                <TableCell align='left'>{translate('ra.field.created_at')}</TableCell>
                <TableCell align='left'>{translate('ra.title.last_login')}</TableCell>
                {hasDevicesEditPermissions &&
                  <TableCell align='left'>{translate('ra.field.is_active')}</TableCell>
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {React.Children.toArray(
                list?.map((row) => {
                  const { user_agent, created_at, last_login, is_active, id, user_id } =
                    row
                  return (
                    <>
                      <TableRow
                        key={id}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          backgroundColor: is_active ? 'white' : '#f9f9f9',
                        }}
                      >
                        <TableCell align='left'>{user_agent}</TableCell>
                        <TableCell align='left'>{formatDateTime(created_at)}</TableCell>
                        <TableCell align='left'>{formatDateTime(last_login)}</TableCell>
                        {hasDevicesEditPermissions &&
                          <TableCell align='left'>
                            {
                              <Button
                              size='small'
                              startIcon={is_active ? <Delete /> : <Add />}
                              color={is_active ? 'error' : 'success'}
                              onClick={(e) => handleButton(id, is_active, user_id)}
                            >
                              {is_active ? translate('ra.action.disable') : translate('ra.action.enable')}
                            </Button>
                            }
                          </TableCell>
                        }
                      </TableRow>
                    </>
                  )
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  )
}
